// extracted by mini-css-extract-plugin
export default {"container":"Pagination_container__DgzGU","containerButtons":"Pagination_containerButtons__VGHFG","buttons":"Pagination_buttons__E8nXy","current":"Pagination_current__V0irA"};